import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { LocaleSharedModule } from '@app/i18n/locale-shared.module';
import { logger } from '@core/helpers/logger';
import { ContextService, EventsSequenceExtended } from '@core/services';
import { ChangableComponent } from '@models/changable.component';
import { Classroom, Router as ContentRouter } from 'lingo2-models';
import { DateFnsModule } from 'lingo2-ngx-date-fns';
import { ClickOutsideModule } from 'ng-click-outside';
import { DeviceDetectorService } from 'ngx-device-detector';
import { OnUiButtonModule, OnUiButtonState } from 'onclass-ui';
import { i18nService as TranslateService } from '../../../../../i18n/translate.service';

const daysOfWeek = ['su', 'mo', 'tu', 'we', 'th', 'fr', 'sa', 'su'];

@Component({
  selector: 'app-course-card',
  standalone: true,
  imports: [LocaleSharedModule, CommonModule, OnUiButtonModule, DateFnsModule, ClickOutsideModule],
  templateUrl: './course-card.component.html',
  styleUrls: ['./course-card.component.scss'],
})
export class CourseCardComponent extends ChangableComponent implements OnInit {
  deviceService = inject(DeviceDetectorService);
  private translate = inject(TranslateService);
  private router = inject(Router);
  private context = inject(ContextService);

  @Input() public course: EventsSequenceExtended;
  @Output() public courseSelected = new EventEmitter<EventsSequenceExtended>();
  public weekdays: number[];
  public meetingsCount: number;
  public isShowAllClasses: boolean;
  public btnState: OnUiButtonState = 'default';
  public debug$ = this.context.debug$;

  public ngOnInit() {
    this.prepareCard();
  }

  private prepareCard(): void {
    this.weekdays = this.course.user_service?.options?.weekdays;
    this.meetingsCount = this.course.user_service?.options?.meetings_limit;
  }

  public showMore() {
    this.isShowAllClasses = !this.isShowAllClasses;
  }

  public get weekdaysToString(): string {
    return this.weekdays?.map((_d) => this.translate.directInstant(`days-of-week.${daysOfWeek[_d]}`)).join(', ');
  }

  public weekDayName(date: Date): string {
    return this.translate.directInstant(`days-of-week.${daysOfWeek[date.getDay()]}`);
  }

  public selectService() {
    this.btnState = 'progress';
    this.courseSelected.emit(this.course);
  }

  public goToClassroom() {
    this.router.navigate([...this.classroomRoute(this.course.meeting?.classroom)]).catch(logger.error);
  }

  public classroomRoute(classroom: Classroom): string[] {
    return ContentRouter.classroomRoute(classroom);
  }

  public trackByFn(index) {
    return index;
  }
}
